import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import {getTemplateFileXlsx} from "../templates/CostUpload/FileReceiver";
import { getAPI } from "../backend/commons";

export const downloadTemplateFile = async (fileName) => {
    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return;
    }

    const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.svcDownloadTemplate}`;
    const response = await getAPI(apiUrl, tokenInfo);
    

    if (!response.ok) {
        throw new Error(`Error while downloading the cost template file: ${response.statusText}`);
    }

 if (response && response.status === 200) {
         const contentDisposition = response.headers.get("Content-Disposition");
 
        let fileNameFromResponse = fileName; // default
        if (contentDisposition && contentDisposition.includes("filename=")) {
            const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (match != null && match[1]) {
                fileNameFromResponse = match[1].replace(/['"]/g, ""); // remove quotes
            }
        }
        await getTemplateFileXlsx(response, fileNameFromResponse);
    } else {
        const errorData = await response.json();
        AlertManager.error(errorData.message || response.statusText, { contactSupport: false });
    }

};
